<template>
		<v-card>
			<v-card-title class="title primary--text secondary" v-translate>Osteopathy Test</v-card-title>
			<v-card-text class="pa-0">
				<v-container fluid class="pa-5 pb-0">
					<v-row no-gutters justify="center" align="center">
						<OsteopathyBody ref="osteoBody" :test="test" :gender="gender" :edit="edit" :results="results" />
					</v-row>
				</v-container>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-btn v-if="results" color="primary darken-1" text @click="hide">
					<translate>Close</translate>
				</v-btn>
				<v-btn v-else color="primary darken-1" text @click="hide">
					<translate>Cancel</translate>
				</v-btn>
				<v-spacer></v-spacer>
				<v-btn
					v-if="!edit && !results"
					color="primary darken-1"
					text
					@click="submitTest"
				>
					<translate>Create</translate>
				</v-btn>
				<v-btn v-if="edit" color="primary darken-1" text @click="editTest">
					<translate>Save</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
</template>

<script>
import OsteopathyBody from "@/components/appointment/tests/osteo/OsteopathyBody.vue";
import axios from "axios";
import { mapGetters } from 'vuex'

export default {
	name: "OsteopathyForm",
	props: {
		test: {
			default: () => ({})
		},
		edit: {
			default: false
		},
		results: {
			default: false
		},
		gender: {
			default: "male"
		}
	},
	components: {
		OsteopathyBody
	},
	data: () => ({}),
	methods: {
		submitTest() {
			console.log("NEW");
			console.log(this.test);
			const formData = new FormData();
			formData.append("kind", "exam");
			formData.append("module", "osteo");
			formData.append("info", JSON.stringify(this.test));
			this.$emit("create-test", formData);
			this.hide();
		},
		editTest() {
			console.log("EDITED");
			console.log(this.test);
			const formData = new FormData();
			formData.append("kind", "exam");
			formData.append("module", "osteo");
			formData.append("info", JSON.stringify(this.test));
			this.$emit("edit-test", formData);
			this.hide();
		},
		hide() {
			this.$emit("hide");
		},
		refresh() {
			console.log("REFRESH");
			this.$refs.osteoBody.init();
		}
	},
	computed: {
		...mapGetters({
      tourStep: 'tourStepEvent'
    })
	},
	created() {
		if(!this.edit && !this.results) {
			axios
				.get("/osteopathy/test/new")
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
						this.test = response.data;
					}
				})
				.catch(error => console.log(error));
		}
	},
	watch: {
		tourStep(value) {
			if(value == 'tour-test-osteo-select') {
				this.$refs.osteoBody.selectShoulder();
				this.test.shoulder.tests[0].right.result = true;
			}
			else if(value == 'tour-test-osteo-submit') {
				this.submitTest();
			}
		}
	}
};
</script>